'use strict';

angular.module('study.dashboard', [
    'ecrd.sites',
    'route',
    'study.i18n',
]);
